const firebaseConfig = {
    apiKey: "AIzaSyCN5tuXu6TJ6ptK897YKO0ZuFvC42Ik4a4",
    authDomain: "creative-agency-9b5c3.firebaseapp.com",
    databaseURL: "https://creative-agency-9b5c3.firebaseio.com",
    projectId: "creative-agency-9b5c3",
    storageBucket: "creative-agency-9b5c3.appspot.com",
    messagingSenderId: "416991022864",
    appId: "1:416991022864:web:e8ab6de6fdf8a12ef65f95"
};

export default firebaseConfig;